import React from "react";
import reminder from "../assets/Reminders.png";
import alarm from "../assets/Alarm Clock.png";
import { NavLinks } from "../reusable/NavLinks";

export const HeroPage = () => {
  return (
    <div className="home" id="home">
      <NavLinks />
      <section className="hero-section is-fullheight is-dark is-bold">
        <div className="hero-body">
          <div className="container is-fluid has-text-centered">
            {/* <h1 className="title">APOSTOLIC COMMUNITY</h1>
            <h2 className="subtitle">Needing Jesus Christ Together</h2>
            <button className="button is-light is-medium mt-4">
              Save your spirit
            </button> */}
          </div>
        </div>
      </section>

      <section className="section has-background-info has-text-white py-6">
        <div className="container is-fluid">
          <div className="columns is-vcentered is-centered has-text-centered">
            {/* Left content: Title, Date, Icons --> */}
            <div className="column is-narrow is-flex is-gap-4">
              <p className="title is-5 has-text-white mb-2 has-text-left">
                Spreading the Gospel
                <br />
                to all
              </p>
              <div className="is-flex  is-justify-content-center is-gap-3">
                <span className="icon-text ">
                  <span className="icon mr-4">
                    <img
                      src={reminder}
                      alt="Icon 1"
                      style={{ width: "31px", height: "auto" }}
                    />
                  </span>
                  <span
                    className="has-text-weight-bold"
                    style={{ textAlign: "left" }}
                  >
                    28 April 2025
                  </span>
                </span>
                <span className="icon-text ">
                  <span className="icon mr-4">
                    <img
                      src={alarm}
                      alt="Icon 1"
                      style={{ width: "31px", height: "auto" }}
                    />
                  </span>
                  <span
                    className="has-text-weight-bold"
                    style={{ textAlign: "left", width: "70%" }}
                  >
                    Tuesday,09.00 am to 05.00 pm
                  </span>
                </span>
              </div>
            </div>
            {/*  Right content: Countdown */}
            <div className="column is-5">
              <p className="subtitle is-6 has-text-white mb-3 has-text-weight-bold">
                Our Next Event Starts in
              </p>
              <div className="box bg-custom-blue no-radius counter-box">
                <div className="columns is-mobile  is-centered is-variable is-5 py-5">
                  <div className="column is-narrow has-text-centered custom-mobile-gap">
                    <p className="title is-8 has-text-white ">09</p>
                    <p className="subtitle is-7 has-text-white has-text-weight-bold">
                      Days
                    </p>
                  </div>
                  <div className="column is-narrow has-text-centered custom-mobile-gap">
                    <p className="title is-8 has-text-white">24</p>
                    <p className="subtitle is-7 has-text-white has-text-weight-bold">
                      Hours
                    </p>
                  </div>
                  <div className="column is-narrow has-text-centered custom-mobile-gap">
                    <p className="title is-8 has-text-white">54</p>
                    <p className="subtitle is-7 has-text-white has-text-weight-bold">
                      Minutes
                    </p>
                  </div>
                  <div className="column is-narrow has-text-centered custom-mobile-gap">
                    <p className="title is-8 has-text-white">09</p>
                    <p className="subtitle is-7 has-text-white has-text-weight-bold">
                      Seconds
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
